import { Card, Checkbox, Heading } from "@/components/ui"
import { useId } from "react"

type OrderUpdatesPreferenceProps = {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

/** "Avisos do pedido pelo WhatsApp" on the review step: one box, on unless the customer turned the order updates off. */
export function OrderUpdatesPreference({ checked, onCheckedChange }: OrderUpdatesPreferenceProps) {
  const titleId = useId()

  return (
    <Card as="section" padding="md" className="flex flex-col gap-3" aria-labelledby={titleId}>
      <Heading id={titleId} level={2} size="card">
        Avisos do pedido pelo WhatsApp
      </Heading>
      <Checkbox
        checked={checked}
        onCheckedChange={onCheckedChange}
        label="Receber atualizações do meu pedido pelo WhatsApp"
        description="Avisamos quando o pedido for confirmado, sair para entrega e chegar."
      />
    </Card>
  )
}
